import { useState } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import HowItWorks from "@/components/HowItWorks";
import DiagnosticQuiz from "@/components/DiagnosticQuiz";
import ResultsSection from "@/components/ResultsSection";
import Footer from "@/components/Footer";

const RelationshipQuiz = () => {
  const [showQuiz, setShowQuiz] = useState(false);
  const [results, setResults] = useState(null);
  const [userName, setUserName] = useState("");

  const handleStartQuiz = () => {
    setShowQuiz(true);
    setResults(null);
    setTimeout(() => {
      document.getElementById('quiz')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleQuizComplete = (quizResults, userData) => {
    setResults(quizResults);
    setUserName(userData.name);
    setShowQuiz(false);
    setTimeout(() => {
      document.getElementById('results')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleRetakeQuiz = () => {
    localStorage.removeItem('siwon_quiz_results');
    localStorage.removeItem('siwon_user_data');
    setResults(null);
    setShowQuiz(true);
    setTimeout(() => {
      document.getElementById('quiz')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="min-h-screen" data-testid="relationship-quiz-page">
      <Header />
      
      {/* Hero Section - show when not in quiz or results */}
      {!showQuiz && !results && (
        <HeroSection onStartQuiz={handleStartQuiz} />
      )}

      {/* How It Works - show when not in quiz/results */}
      {!showQuiz && !results && (
        <HowItWorks />
      )}

      {/* Quiz Section */}
      {showQuiz && !results && (
        <DiagnosticQuiz onComplete={handleQuizComplete} />
      )}

      {/* Results Section */}
      {results && (
        <>
          <div className="pt-20" />
          <ResultsSection results={results} userName={userName} />
          <div className="bg-cream-dark py-8 text-center">
            <button
              onClick={handleRetakeQuiz}
              className="text-primary hover:text-accent transition-colors font-medium underline underline-offset-4"
              data-testid="retake-quiz-btn"
            >
              Retake the Diagnostic Quiz
            </button>
          </div>
        </>
      )}

      <Footer onStartQuiz={handleStartQuiz} />
    </div>
  );
};

export default RelationshipQuiz;
